module.exports = __webpack_public_path__ + "static/media/tutorial_journey.36b87edf.jpg";